module.exports = __webpack_public_path__ + "img/wakauto_180A.e4773409.png";